import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { CompanyServiceAbstract, UserServiceAbstract } from '@mare-common/ngx-mare-user';
// import { ContractNoticeComponentsModule } from '@mare-common/ngx-contract-notice-components';

@Component({
  selector: 'app-bandi',
  templateUrl: './bandi.component.html',
  styleUrls: ['./bandi.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class BandiComponent implements OnInit{
  @ViewChild('companytenders') companytenders: any;
  serviceendpoint = 'remote-contract-notice-service';
  // piva = '04404960611';  //'02834380046';
  piva!: string;
  pagetitle: string = 'bandi';
  user: any;
  company: any;
 

  constructor(
    private userService: UserServiceAbstract,
    private companyService: CompanyServiceAbstract
  ) { 
     this.userService.getUser().then((user: any) => {
        this.user = user;
        
        this.companyService.getCompany().then((company: any) => {
          this.company = company;
          this.piva = this.company.piva;
        });
      });
      
    
  }
  ngOnInit(): void {
    // console.log('bandi',this.companytenders, this.company);
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
  }
}
